// @flow

import { LOCATION_CHANGE } from "connected-react-router";
import { cloneObject } from "@utils/object";
import {
  // Hierarchy Admin
  DeleteBranch,
  DeleteBranchSuccess,
  DeleteBranchError,
  ToggleAddEditShiftPatternModal,
  ToggleAddEditContactModal,
  SetNotificationContact,
  DiscardDraft,
  DiscardDraftSuccess,
  DiscardDraftError,
  GetActiveHierarchyTree,
  GetActiveHierarchyTreeSuccess,
  GetActiveHierarchyTreeError,
  GetDraftHierarchyTree,
  GetDraftHierarchyTreeChangelog,
  GetDraftHierarchyTreeChangelogSuccess,
  GetDraftHierarchyTreeChangelogError,
  GetDraftHierarchyTreeSuccess,
  GetDraftHierarchyTreeError,
  MoveBranch,
  MoveBranchSuccess,
  MoveBranchError,
  RenameBranch,
  RenameBranchError,
  RenameBranchSuccess,
  ToggleEditDraftHierarchyModal,
  ViewScopeChanges,
  SelectOrganizationalUnit,
  GetNotificationContacts,
  GetNotificationContactsError,
  GetHierarchyNotificationContactsSuccess,
  GetHierarchyShiftPatterns,
  GetHierarchyShiftPatternsError,
  GetHierarchyShiftPatternsSuccess,
  GetHierarchyNotificationsSummary,
  GetHierarchyNotificationsSummarySuccess,
  GetHierarchyNotificationsSummaryError,
  GetHierarchyShiftPatternSchema,
  GetHierarchyShiftPatternSchemaSuccess,
  GetHierarchyShiftPatternSchemaError,
  ToggleHierarchySidebar,
  CreateHierarchyShiftPattern,
  UpdateHierarchyShiftPattern,
  UpdateHierarchyShiftPatternSuccess,
  UpdateHierarchyShiftPatternError,
  CreateHierarchyShiftPatternSuccess,
  CreateHierarchyShiftPatternError,
  CreateHierarchyNotification,
  CreateHierarchyNotificationSuccess,
  CreateHierarchyNotificationError,
  UpdateHierarchyNotification,
  UpdateHierarchyNotificationSuccess,
  UpdateHierarchyNotificationError,
  // Changelog
  GetHierarchyChangelog,
  GetHierarchyChangelogSuccess,
  GetHierarchyChangelogError,
  ExportHierarchyChangelog,
  ExportHierarchyChangelogSuccess,
  ExportHierarchyChangelogError,
  GetHierarchyChangelogUsers,
  GetHierarchyChangelogUsersSuccess,
  GetHierarchyChangelogUsersError,
  // Common
  DeleteDepartmentError,
  ExportSimpleList,
  ExportSimpleListSuccess,
  ExportSimpleListError,
  ExportFullList,
  ExportFullListSuccess,
  ExportFullListError,
} from "@modules/hierarchy/constants/actions";
import hierarchy from "./hierarchy/state";
import changelog from "./change-log/state";
import * as hierarchyReducers from "./hierarchy/reducers";
import * as changelogReducers from "./change-log/reducers";
import type { HierarchyChangelogState } from "./change-log/types.js";
import type { HierarchyHierarchyState } from "./hierarchy/types.js";

export type HirarchyMainStateType = $Exact<{
  changelog: HierarchyChangelogState,
  hierarchy: HierarchyHierarchyState,
}>;

export const initialState: HirarchyMainStateType = {
  changelog,
  hierarchy,
};

const onLocationChange = (state: Object) => () => {
  return {
    ...state,
    isLoading: false,
    error: null,
  };
};

export default (state: Object = initialState, action: Object) => {
  const act = {
    [DeleteBranch]: hierarchyReducers.startLoading,
    [DeleteBranchSuccess]: hierarchyReducers.finishLoading,
    [DeleteBranchError]: hierarchyReducers.finishLoading,
    [GetActiveHierarchyTree]: hierarchyReducers.startLoading,
    [GetActiveHierarchyTreeSuccess]: hierarchyReducers.onGetActiveHierarchyTreeSuccess,
    [GetActiveHierarchyTreeError]: hierarchyReducers.onError,
    [GetDraftHierarchyTree]: hierarchyReducers.startLoading,
    [GetDraftHierarchyTreeChangelog]: hierarchyReducers.startLoading,
    [GetDraftHierarchyTreeChangelogSuccess]:
      hierarchyReducers.onGetDraftHierarchyTreeChangelogSuccess,
    [ToggleAddEditShiftPatternModal]: hierarchyReducers.onToggleAddEditShiftPatternModal,
    [ToggleAddEditContactModal]: hierarchyReducers.onToggleAddEditContactModal,
    [SetNotificationContact]: hierarchyReducers.onSetNotificationContact,
    [GetDraftHierarchyTreeChangelogError]: hierarchyReducers.onError,
    [GetHierarchyShiftPatternSchema]: hierarchyReducers.startLoading,
    [GetHierarchyShiftPatternSchemaSuccess]:
      hierarchyReducers.onGetHierarchyShiftPatternSchemaSuccess,
    [GetHierarchyShiftPatternSchemaError]: hierarchyReducers.onError,
    [GetDraftHierarchyTreeSuccess]: hierarchyReducers.onGetDraftHierarchyTreeSuccess,
    [DiscardDraft]: hierarchyReducers.startLoading,
    [DiscardDraftSuccess]: hierarchyReducers.onDiscardDraftSuccess,
    [DiscardDraftError]: hierarchyReducers.onError,
    [GetDraftHierarchyTreeError]: hierarchyReducers.onError,
    [MoveBranch]: hierarchyReducers.startLoading,
    [MoveBranchSuccess]: hierarchyReducers.finishLoading,
    [MoveBranchError]: hierarchyReducers.finishLoading,
    [RenameBranch]: hierarchyReducers.startLoading,
    [RenameBranchError]: hierarchyReducers.finishLoading,
    [RenameBranchSuccess]: hierarchyReducers.finishLoading,
    [ViewScopeChanges]: hierarchyReducers.startLoading,
    [GetNotificationContacts]: hierarchyReducers.startLoading,
    [GetNotificationContactsError]: hierarchyReducers.onError,
    [GetHierarchyNotificationContactsSuccess]: hierarchyReducers.onGetNotificationContactsSuccess,
    [GetHierarchyShiftPatterns]: hierarchyReducers.startLoading,
    [GetHierarchyShiftPatternsError]: hierarchyReducers.onError,
    [GetHierarchyShiftPatternsSuccess]: hierarchyReducers.onGetHierarchyShiftPatternsSuccess,
    [GetHierarchyNotificationsSummary]: hierarchyReducers.startLoading,
    [GetHierarchyNotificationsSummarySuccess]:
      hierarchyReducers.onGetHierarchyNotificationsSummarySuccess,
    [GetHierarchyNotificationsSummaryError]: hierarchyReducers.onError,
    [ToggleEditDraftHierarchyModal]: hierarchyReducers.onToggleEditDraftHierarchyModal,
    [SelectOrganizationalUnit]: hierarchyReducers.onSelectOrganizationalUnit,
    [ToggleHierarchySidebar]: hierarchyReducers.onToggleHierarchySidebar,
    [ExportSimpleList]: hierarchyReducers.startLoading,
    [ExportSimpleListSuccess]: hierarchyReducers.finishLoading,
    [ExportSimpleListError]: hierarchyReducers.finishLoading,
    [ExportFullList]: hierarchyReducers.startLoading,
    [ExportFullListSuccess]: hierarchyReducers.finishLoading,
    [ExportFullListError]: hierarchyReducers.finishLoading,
    [CreateHierarchyShiftPattern]: hierarchyReducers.startLoading,
    [CreateHierarchyShiftPatternSuccess]: hierarchyReducers.finishLoading,
    [CreateHierarchyShiftPatternError]: hierarchyReducers.finishLoading,
    [UpdateHierarchyNotification]: hierarchyReducers.startLoading,
    [UpdateHierarchyNotificationSuccess]: hierarchyReducers.finishLoading,
    [UpdateHierarchyNotificationError]: hierarchyReducers.finishLoading,
    [CreateHierarchyNotification]: hierarchyReducers.startLoading,
    [CreateHierarchyNotificationSuccess]: hierarchyReducers.finishLoading,
    [CreateHierarchyNotificationError]: hierarchyReducers.finishLoading,
    [UpdateHierarchyShiftPattern]: hierarchyReducers.startLoading,
    [UpdateHierarchyShiftPatternSuccess]: hierarchyReducers.finishLoading,
    [UpdateHierarchyShiftPatternError]: hierarchyReducers.finishLoading,

    // Common
    [LOCATION_CHANGE]: onLocationChange,

    // Changelog
    [GetHierarchyChangelog]: changelogReducers.startLoading,
    [GetHierarchyChangelogSuccess]: changelogReducers.onGetHierarchyChangelogSuccess,
    [GetHierarchyChangelogError]: changelogReducers.onChangelogError,
    [ExportHierarchyChangelog]: changelogReducers.startLoading,
    [ExportHierarchyChangelogSuccess]: changelogReducers.finishLoading,
    [ExportHierarchyChangelogError]: changelogReducers.onChangelogError,
    [GetHierarchyChangelogUsers]: changelogReducers.startLoading,
    [GetHierarchyChangelogUsersSuccess]: changelogReducers.onGetHierarchyChangelogUsersSuccess,
    [GetHierarchyChangelogUsersError]: changelogReducers.onChangelogError,

    [DeleteDepartmentError]: hierarchyReducers.onError,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
